import Registration from '@/helpers/Registration';
import Requests from '@/helpers/Request';
import router from '@/router';

export default {
  namespaced: true,
  state: () => ({
    active: {},
    archive: {},
    isLoading: false,
  }),
  mutations: {
    setPlaybackToArchive(state) {
      state.playbackArchive[state.active.id] = { ...state.active };
    },
    setActivePlayback(state, context) {
      state.active = context;
    },
    setIsLoading(state, value) {
      state.isLoading = value;
    },
  },
  actions: {
    init({ commit, getters }, { id, playback, reset }) {
      commit('setIsLoading', true);
      if (!id && !playback) {
        commit('setIsLoading', false);
        router.go(-1);
        return;
      }
      if (id === getters.getCurrentId) return;
      if (state.archive[id]) {
        dispatch('setNewPlayback', state.archive[id]);
        return;
      }
      dispatch('setNewPlayback', playback);
    },
    setNewPlayback({ commit, getters }, context) {
      if (getters.getCurrentId !== undefined && getters.getCurrentId !== null) {
        commit('setPlaybackToArchive');
      }
      commit('setActivePlayback', context);
      commit('setIsLoading', false);
    },
  },
  getters: {
    getCurrentId(state) {
      return state.active.id;
    },
    getIsLoading(state) {
      return state.isLoading;
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/playback.js